/**
 * Whether a session or group should show recruiter CRM chrome
 * (Candidates inbox, match %, Results).
 *
 * Learning lessons/courses should not lead people into candidate CRM.
 */

export function isLearningSessionType(sessionType?: string | null): boolean {
  return sessionType === 'presentation';
}

export function isScreeningSessionType(sessionType?: string | null): boolean {
  return sessionType === 'company-job-interview';
}

export function isLearningGroupType(
  groupType?: 'learning' | 'screening' | 'research' | string | null,
): boolean {
  return (groupType ?? 'learning') === 'learning';
}

/** Show Candidates / Results / candidate meta for this session template. */
export function showsCandidatesCrm(sessionType?: string | null): boolean {
  if (isLearningSessionType(sessionType)) return false;
  // Default unknown types to screening so existing interview sessions keep CRM.
  return true;
}

/** Show Candidates for a session group. */
export function showsGroupCandidatesCrm(
  groupType?: 'learning' | 'screening' | 'research' | string | null,
): boolean {
  return !isLearningGroupType(groupType);
}

const SCREENING_USE_CASES = new Set([
  'screen_candidates',
  'assess_language',
  'pre_cas_interview',
  'admissions_screening',
  'general_screening',
]);

/** Picked a screening use case at signup. */
export function isScreeningUseCase(useCase?: string | null): boolean {
  return SCREENING_USE_CASES.has(useCase ?? '');
}

/**
 * Sees candidate feedback: screening signups, and invited teammates (they join an
 * existing workspace and never pick a use case).
 */
export function seesCandidateFeedback(
  user?: { primary_use_case?: string | null; role?: string | null } | null,
): boolean {
  if (!user) return false;
  if (isScreeningUseCase(user.primary_use_case)) return true;
  return !user.primary_use_case && user.role !== 'company_admin';
}
